import { render } from "./MusicDownloads.vue?vue&type=template&id=49fcac27&scoped=true"
import script from "./MusicDownloads.vue?vue&type=script&lang=js"
export * from "./MusicDownloads.vue?vue&type=script&lang=js"

import "./MusicDownloads.vue?vue&type=style&index=0&id=49fcac27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fcac27"]])

export default __exports__